import { useQuery } from "@tanstack/react-query";
import { dashboardService } from "../../api/dashboardService";
import { getEmployeeId } from "../../utils/session";

export const DASHBOARD_KEY = ["me:dashboard"];

export const useDashboard = () =>
  useQuery({
    queryKey: DASHBOARD_KEY,
    queryFn: dashboardService.getMine,
    enabled: !!getEmployeeId(),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: true,
    retry: (count, error) => error?.response?.status !== 403 && count < 2,
  });
